import useFeatureSettingsUpdate from './useFeatureSettingsUpdate';

export default function useDailySignOffSettingsUpdate() {
  return useFeatureSettingsUpdate('dailySignOff');
}
